export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q04_b.acefc878.png";